// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from '@emotion/styled';
import { Button } from '@carbon/react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@emotion/react';
import { node, func, array } from 'prop-types';
import { X } from 'lucide-react';

import useProducts from 'Hooks/useProducts';

const StickyFiltersHeaderMobile = styled.div`
  position: sticky;
  display: none;
  top: 0;
  margin: 0 -20px 20px;
  padding: 20px;
  background: #fff;
  box-shadow: 0px 3px 6px #00000029;
  z-index: 9001;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    span {
      font-size: 20px;
      line-height: 24px;
      font-weight: 600;
    }

    .showSelection {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 8px 20px;
      font-size: 16px;
      line-height: 28px;
    }
  }

  .footer {
    display: flex;
    justify-content: flex-end;

    button {
      background: transparent;
      color: #D52B1E;

      svg {
        margin-right: 8px;
      }
    }
  }

  @media screen and (max-width: ${ props => props.theme.device.mobile }) {
    display: block;
  }
`;

const FiltersHeaderMobile = ({ children, activeFilters, setMobileFiltersOpen, clearFilters }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { data } = useProducts();

  return (
    <StickyFiltersHeaderMobile theme={ theme }>
      <div className="header">
        <span>{ `${ data?.totalRecords } ${ t('products.products') }` }</span>
        <Button
          className="showSelection"
          kind="danger"
          onClick={ () => setMobileFiltersOpen(false) }
        >
          { t('products.showSelection') }
        </Button>
      </div>
      { children }
      { !!Object.keys(activeFilters).length && (
        <div className="footer">
          <Button
            onClick={ clearFilters }
          >
            <X />
            { t('products.clearAllFilters') }
          </Button>
        </div>
      ) }
    </StickyFiltersHeaderMobile>
  );
};

FiltersHeaderMobile.propTypes = {
  children: node,
  activeFilters: array,
  setMobileFiltersOpen: func,
  clearFilters: func,
};

export default FiltersHeaderMobile;
